import { render, staticRenderFns } from "./DashboardUserCold.vue?vue&type=template&id=9a49ce52&scoped=true&"
import script from "./DashboardUserCold.vue?vue&type=script&lang=js&"
export * from "./DashboardUserCold.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserCold.vue?vue&type=style&index=0&id=9a49ce52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a49ce52",
  null
  
)

export default component.exports